import { get, put, type RequestConfig } from "../shared/api-client";
import type {
  AdminUserRecord,
  AuthPermission,
  UserListResponse,
  UserPermissionsPayload,
} from "@project/types/user-permission";

const USERS_BASE = "/users";
const PERMISSIONS_BASE = "/auth-permissions";
export const PERMISSION_APP = "Jivandhara";
const SILENT: RequestConfig = { showNotification: false };

type ListEnvelope<T> = { data?: T[]; results?: T[] };

function unwrapList<T>(response: T[] | ListEnvelope<T> | undefined): T[] {
  if (Array.isArray(response)) {
    return response;
  }
  return response?.data ?? response?.results ?? [];
}

class UserPermissionService {
  /** The users API returns every user at once as `{ success, users, permissions }`. */
  listUsers = async (): Promise<AdminUserRecord[]> => {
    const response = await get<UserListResponse | AdminUserRecord[]>(
      `${USERS_BASE}/`,
      SILENT
    );
    if (Array.isArray(response)) {
      return response;
    }
    return response?.users ?? [];
  };

  listPermissions = async (
    app: string = PERMISSION_APP
  ): Promise<AuthPermission[]> => {
    const response = await get<AuthPermission[] | ListEnvelope<AuthPermission>>(
      `${PERMISSIONS_BASE}/`,
      { ...SILENT, params: { app } }
    );
    return unwrapList(response);
  };

  /** Replaces the user's direct permissions with the given list. */
  assignPermissions = async (
    userId: string,
    permissionIds: number[]
  ): Promise<void> => {
    await put<unknown, UserPermissionsPayload>(
      `${USERS_BASE}/${userId}/permissions/`,
      { user_permissions: permissionIds },
      SILENT
    );
  };
}

export const userPermissionService = new UserPermissionService();
